import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {ReelsModule} from '@gongxigames/framework/slot/modules/reels';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {FirecatcherConstants} from '@gongxigames/framework/slot/modules/reels/FirecatcherConstants';
import {FirecatcherReelsModule} from '@gongxigames/framework/slot/modules/reels/FirecatcherReelsModule';
import {ReelsSequentialStopState} from '@gongxigames/framework/slot/modules/reels/states/ReelsSequentialStopState';
import {Timer} from '@gongxigames/framework/core';

export class FirecatcherReelsStopState extends ReelsSequentialStopState {
    protected _prizeCount = -1;
    protected _stoppedReelsCount = -1;

    public onEnterState(): void {
        this._currentStoppingReel = -1;
        this._stoppedReelsCount = this.view.reels.filter(r => r.isStopped).length;
        this._prizeCount = this.module.prizeCountOnStoppedReels;

        this.stopNextReel();
    }

    protected stopNextReel(): void {
        const REELS_AMOUNT: number = this.view.reelConstants.REELS_AMOUNT;

        do {
            this._currentStoppingReel++;
        } while (this._currentStoppingReel < REELS_AMOUNT && this.view.isReelStopped(this._currentStoppingReel));

        if (this._currentStoppingReel >= REELS_AMOUNT) {
            this._currentTimeout && this._currentTimeout.stop();
        } else {
            if (this._stoppedReelsCount < REELS_AMOUNT - 1) {
                const isLastSpin = this._stoppedReelsCount === REELS_AMOUNT - 2;
                let additionalTime: number = isLastSpin ? this.lastRespinAdditionalTime : 0;

                if (isLastSpin && this.module.respinsCount === 1) {
                    additionalTime += this.lastTryAdditionalTime;
                }
                this._currentTimeout = new Timer(this.stopNextReel.bind(this), this.reelStopTime + additionalTime, true);
                this.module.updateManager.add(this._currentTimeout);
            }

            this.tryStopReel(this._currentStoppingReel);
        }
    }

    protected tryStopReel(reelIndex: number): void {
        if (this.module.logic.getFirecatcherPrizes()[reelIndex]) {
            this._prizeCount += 1;
        }

        this._stoppedReelsCount += 1;
        this.view.tryStoppingReel(reelIndex);
    }

    protected onSpinEnded(): void {
        if (this.module.logic.nextAction === Action.RESPIN) {
            this.module.gotoState(ReelsModule.RESPIN_BASIC_STATE);
        } else {
            this.module.gotoState(ReelsModule.BASIC_STATE);
        }
        this.module.eventManager.emit(ReelsEvents.SPIN_ENDED);
    }

    protected onTryinToStopBySpinButton(): void {
        this._anticipationAnimTimer && this._anticipationAnimTimer.stop();
        this.module.anticipatedReels.length = 0;
        this.module.gotoState(ReelsModule.RESPIN_QUICKSTOP_STATE);
    }

    protected get module(): FirecatcherReelsModule {
        return this._module as FirecatcherReelsModule;
    }

    protected get reelStopTime(): number {
        return this.module.isTurboSpin() ? 0 : FirecatcherConstants.PRIZE_COUNT_STOP_TIMING_MAP[this._prizeCount].delay;
    }

    protected get lastRespinAdditionalTime(): number {
        return this.module.isTurboSpin() ? 0 : FirecatcherConstants.LAST_RESPIN_ADDITIONAL_TIME;
    }

    protected get lastTryAdditionalTime(): number {
        return this.module.isTurboSpin() ? 0 : FirecatcherConstants.LAST_TRY_ADDITIONAL_TIME;
    }
}
